import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_mof_item_hdr_RowClass,
} from '../../../dbschema';

export class MofItemHdrContainerModel extends BaseContainerModel {
  bl_aat_mof_item_hdr: bl_aat_mof_item_hdr_RowClass = new bl_aat_mof_item_hdr_RowClass();
}
